import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";

export default function HotComics() {
  const hotComics = comics.filter((c) => c.featured).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              精选最受欢迎的漫画作品，不容错过
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-accent-500 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}